import React, { useId } from "react";
import { getBasename, getClassName, humanReadableBytes } from "@sscs/utils";
import { CloseIcon, FileIcon } from "../../icons";
import DotSeparator from "../DotSeparator/DotSeparator";
import IconButton from "../IconButton/IconButton";
import { CopyHash } from "../index";
import styles from "./fileBadge.module.scss";
const FileBadge = ({ path, size, sha256, variant = "framed", onRemove, className, }) => {
    const hashCopyId = useId();
    return (React.createElement("div", { className: getClassName(styles.root, { [styles.framed]: variant === "framed" }, className) },
        React.createElement(FileIcon, { size: "md", color: "inherit" }),
        React.createElement("span", { className: styles.text },
            React.createElement("span", { className: styles.name, title: path }, getBasename(path)),
            React.createElement("span", { className: styles.meta },
                humanReadableBytes(size),
                sha256 !== null && (React.createElement(React.Fragment, null,
                    React.createElement(DotSeparator, null),
                    React.createElement("span", { className: styles["hash-group"] },
                        "SHA256:\u00A0",
                        React.createElement("span", { className: styles.hash }, sha256),
                        "\u00A0",
                        React.createElement(CopyHash, { id: hashCopyId, sha256: sha256, className: styles["copy-hash"] })))))),
        onRemove && (React.createElement(IconButton, { "aria-label": "Remove file", tooltipTitle: "Remove file", onClick: onRemove },
            React.createElement(CloseIcon, null)))));
};
export default FileBadge;
//# sourceMappingURL=FileBadge.js.map